import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const evaluateRuleSetPreview = api(async function evaluateRuleSetPreview({ ruleSetId, regimeId, rateCardId }) {
    return query(
        gql`
            query EvaluateRuleSetPreview($ruleSetId: String!, $regimeId: String!, $rateCardId: String) {
                evaluateRuleSetPreview(ruleSetId: $ruleSetId, regimeId: $regimeId, rateCardId: $rateCardId) {
                    totalTasks
                    includedTasks
                    excludedTasks
                    modifiedTasks
                    classificationBreakdown {
                        classification
                        included
                        excluded
                        modified
                    }
                    modifierRuleBreakdown {
                        ruleId
                        ruleName
                        taskCount
                        actionType
                        multiplier
                        costKind
                        fixedAmount
                        timeKind
                        timeValue
                        frequencyMultiplier
                    }
                }
            }
        `,
        { ruleSetId, regimeId, rateCardId: rateCardId || undefined },
        { returns: "evaluateRuleSetPreview" }
    )
})
